import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';

export interface FormViewSwitchV2Props {
  field: IFormFieldV2;
  value: any;
}

export const FormViewSwitchV2: React.FC<FormViewSwitchV2Props> = ({
  field,
  value,
}) => {
  const displayValue =
    value !== undefined
      ? value?.toString()?.toLowerCase() === 'true'
        ? field.switchOptions?.positiveText ?? 'Yes'
        : field.switchOptions?.negativeText ?? 'No'
      : 'N/A';

  const valueColor =
    value !== undefined
      ? value?.toString()?.toLowerCase() === 'true'
        ? 'green'
        : 'red'
      : 'black';

  return (
    <FormViewRowV2 field={field} value={displayValue} valueColor={valueColor} />
  );
};
